export default "__VITE_ASSET__b10f7982__"